// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2kB2H","radioRow":"SimpleQuestionBuilderModal_radioRow__1ym5R"};